import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { FaqService } from '@connect-services/client/services/faq.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-security',
    template: `
        <div class="relative bg-surface-variant flex h-full w-full justify-center items-center">
            <div class="w-full">
                <router-outlet />
            </div>
            <div
                class="absolute bottom-6 left-6 bg-white w-16 aspect-square hover:bg-custom-light-blue gap-0 flex flex-col justify-center items-center rounded-full cursor-pointer group"
                (click)="faqService.redirect()">
                <fa-icon
                    class="text-custom-blue overflow-hidden m-0 p-0 transition-all duration-700 ease-in-out max-h-full group-hover:max-h-0"
                    size="xl"
                    [icon]="['fas', 'question']" />

                <p
                    class="text-custom-blue overflow-hidden m-0 p-0 transition-all duration-700 ease-in-out leading-none max-h-0 group-hover:max-h-full">
                    FAQ
                </p>
            </div>
        </div>
    `,
})
export class SecurityComponent {
    protected readonly faqService = inject(FaqService);
}
